<p-table [value]="form().controls" size="small" >
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 22rem;min-width: 22rem">Utensile</th>
            <th style="white-space: nowrap; width: 3rem">Q.tà</th>
            <th style="width: 100%">Descrizione</th>
            @if(showCost()){<th style="min-width: 6rem; text-align: right;">Costo</th>}
            @if(showRequest() &&  isFormDisabled()){<th style="width: 3rem"></th>}
            @if(!isFormDisabled()){<th style="width: 1rem"></th>}

        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowGroup let-i="rowIndex">
        <tr [formGroup]="$any(rowGroup)">
            <td class="p-0">
              <spike-field-select [initialValue]="organizationStore.getEquipment(rowGroup.get('equipmentId').value)()" formControlName="equipmentId" selectKey="equipmentId" selectValue="shortDescription" listTitle="Seleziona utensile" detailTitle="Dettaglio utensile">
                    <ng-template #list>
                        <spike-organization-list #listRef
                            [modelApi]="equipmentModelApi"
                            [entityApi]="equipmentApi"
                            [etiquetteApi]="equipmentEtiquetteApi"
                            entityKey="equipmentId">
                        </spike-organization-list>
                    </ng-template>
                </spike-field-select>
            </td>
            <td class="p-0"><spike-field-number formControlName="quantity" placeholder="Q.tà"></spike-field-number></td>            
            <td class="p-0"><spike-field-text formControlName="description" placeholder="Descrizione"></spike-field-text></td>
            @if(showCost()){<td class="p-0"><spike-field-number formControlName ="cost" mode="currency" currency="EUR" textAlign="text-right"></spike-field-number></td>}
            @if(showRequest() && isFormDisabled()){<td class="p-0"><p-button label="Richiedi" size="small" (onClick)="createRequest.emit(rowGroup.getRawValue())"></p-button></td>}
            @if(!isFormDisabled()){
            <td class="cursor-pointer p-0">
                <div (click)="deleteRow.emit(i)"><i class="pi pi-trash" style="color: var(--p-button-text-danger-color)"></i></div>
             }
        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        @if(!isFormDisabled()){
        <div class="flex">
            <div class="flex justify-content-end">
                <p-button label="Aggiungi utensile" icon="pi pi-plus" [text]="true" size="small" (onClick)="addRow.emit()"></p-button>
            </div>
        </div>
        }
    </ng-template>
</p-table>

